import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { ForgetPasswordComponent } from "./components/forget-password/forget-password.component";
import { DetailedQuotaComponent } from "./screens/detailed-quota/detailed-quota.component";
import { StatementComponent } from "./screens/user-profile/statement/statement.component";
import { PreviewInvoiceComponent } from "./screens/user-profile/invoice/preview-invoice/preview-invoice.component";
import { InvoiceDetailsComponent } from "./screens/user-profile/invoice/invoice-details/invoice-details.component";
import { InvoiceComponent } from "./screens/user-profile/invoice/invoice.component";
import { LocalMarketComponent } from "./screens/local-market/local-market.component";
import { UserProfileComponent } from "./screens/user-profile/user-profile.component";
import { GlobalMarketsComponent } from "./screens/global-markets/global-markets.component";
import { CompanyProfileComponent } from "./screens/company-profile/company-profile.component";
import { LoginComponent } from "./screens/login/login.component";
import { HomeComponent } from "./screens/home/home.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./services/auth.guard";
import { TradesHistoryComponent } from "./components/trades-history/trades-history.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { CreateUserComponent } from "./components/create-user/create-user.component";
import { VerifyEmailComponent } from "./components/verify-email/verify-email.component";
import { IsMarketGuard } from "./services/is-market.guard";
import { TechnicalReportsComponent } from "./screens/technical-reports/technical-reports.component";
import { IPOComponent } from "./screens/ipo/ipo.component";
import { TestComponent } from "./screens/test/test.component";
import { MutualFundComponent } from "./screens/mutual-fund/mutual-fund.component";
import { GenericReportComponent } from "./reports/generic-report/generic-report.component";

const routes: Routes = [
  {
    path: "",
    component: TestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "home",
    component: TestComponent,
    canActivate: [AuthGuard],
  },
  {
    
    path: "IPO",
    component: IPOComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "test",
    component: TestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "global",
    component: GlobalMarketsComponent,
    canActivate: [AuthGuard, IsMarketGuard],
  },
  {
    path: "local",
    component: LocalMarketComponent,
    canActivate: [AuthGuard, IsMarketGuard],
  },
  {
    path: "invoice",
    component: InvoiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "invoice-detail",
    component: InvoiceDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "company-profile/:symbolCode/:reuters",
    component: CompanyProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "detailed-quota/:symbolCode",
    component: DetailedQuotaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile",
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  }, 
  // TODO: When new design of profile is finished SWITCH "profile-revampe" route with "profile"
  {
    path: 'requests-analysis',
    loadChildren: () => import('./screens/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule)
  },
  {
    path: "reports",
    component: TechnicalReportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tradesHistory",
    component: TradesHistoryComponent,
    canActivate: [AuthGuard],
  },
  { path: "preview-invoice", component: PreviewInvoiceComponent },
  {
    path: "statements",
    component: StatementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "mutual-fund",
    component: MutualFundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "changePassword",
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  { path: "login", component: LoginComponent },
  // { path: "login", component: NewLoginComponent },
  { path: "ForgetPassword", component: ForgetPasswordComponent },
  { path: "VerifyEmail", component: ResetPasswordComponent },
  { path: "CreateOnlineAccount", component: CreateUserComponent },
  { path: "Verification/EmailVerification", component: VerifyEmailComponent },
  {
    path: "landing",
    loadChildren: () => import('./screens/landing/landing.module').then(m => m.LandingModule),
  },
   {
    path: 'generic-report/:reportName/:exportToPdf',
    component: GenericReportComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
